import React, { useState, useCallback } from 'react';
import ExcelValidator from '@utils/excelValidator';

const IDEL = 0,
  SUCCESS = 2,
  FAILURE = 3;

const Badger = ({ status }) => {
  if (status === SUCCESS) {
    return <div className="badger success"> SUCCESS</div>;
  }
  if (status === FAILURE) {
    return <div className="badger error">ERROR</div>;
  }
  return null;
};

const allowedExtensions = ['.xlsx', '.xls'];

const useUpload = (rules, validator) => {
  const [status, setStatus] = useState(IDEL);
  const [errors, setErrors] = useState([]);
  const [file, setFile] = useState(null);

  const onUpload = useCallback(
    (file) => {
      const fileTypeValid = allowedExtensions.some((ext) =>
        file.name?.endsWith(ext),
      );
      if (!fileTypeValid) {
        setStatus(FAILURE);
        setErrors(['Unsupported file type']);
        return;
      }

      const reader = new FileReader();

      reader.onload = async (event) => {
        try {
          const arrayBuffer = event.target.result;

          // Now using async/await
          const validation = await new ExcelValidator(rules).validate(
            arrayBuffer,
            validator,
          );

          if (validation.errors.length === 0) {
            setStatus(SUCCESS);
          } else {
            setStatus(FAILURE);
          }
          setErrors(validation.errors);
        } catch (error) {
          console.error('Excel validation error:', error);
          setStatus(FAILURE);
          setErrors([error.message || 'Failed to parse Excel file']);
        }
      };

      reader.onerror = () => {
        setStatus(FAILURE);
        setErrors(['Failed to read file']);
      };

      // Use readAsArrayBuffer for ExcelJS (more reliable)
      reader.readAsArrayBuffer(file);
      setFile(file);
      return false;
    },
    [rules, validator],
  );

  const clear = () => {
    setFile(null);
    setStatus(IDEL);
    setErrors([]);
  };

  const errorInfo = errors.map((err, i) => <p key={i}>{err}</p>);
  const badge = <Badger status={status} />;
  return {
    badge,
    status,
    onUpload,
    file,
    clear,
    errorInfo,
    isSuccess: status === SUCCESS,
  };
};

export default useUpload;
